//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'

//#endregion

// #region Imports

import { CommonHelper, EventsNames, IUserSession, LocalizationHelper, LogHelper, ToastHelper } from '../../../helpers'
import { DataType } from '../../../helpers/common-helper'
import { Enums } from '../../../models/common'
import { OpConfigurationProfile, OpLocation } from '../../../models/core'
import { OpActionResult, OpLocationConfigurationProfile } from '../../../models/custom'
import { LocationService } from '../../../services/location'
import { ColumnModel, CorrespondingActionTypeModel } from '../../api/api.models'
import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { ActionStatusOptions } from '../../common/action-status/action-status.controller'
import { CommonCreateEdit, CreateEditSection, CreateEditFieldSettings } from '../../common/common.create-edit'
import { ConfirmationOptions } from '../../common/confirmation-popup/confirmation-popup.directive'
import { GridOptions, GridTypes, GridController } from '../../common/grid/grid.controller'
import {
	ILocationsMassSendConfigurationProfile,
	LocationsMassSendConfigurationProfileDataSource,
	LocationsMassSendConfigurationProfileOptions,
} from './locations-mass-send-configuration-profile.interfaces'
import { GridService } from '../../../services/grid'
import { ReferenceTypeService } from '../../../services/reference-type'
import { DataProviderListResult } from '../../../data-provider'
import { OperatorSecurityService } from '../../../services/operator'

// #endregion

// #region LocationsMassSendConfigurationProfileScope

interface LocationsMassSendConfigurationProfileScope extends ng.IScope {
	// #region Properties

	popupVisible: boolean
	title: string
	popupType: any
	titleSummary: string

	isDescriptionShow: boolean
	descriptionHtml: string

	ACTION_STATUS_POPUP_ID: string
	popupId: number
	bulkEditWarningId: any

	isStartButtonFinished: boolean
	isStarted: boolean

	uploadedPercent: number
	actualLocation: number

	profileSelectBoxItems: CorrespondingActionTypeModel[]

	// #endregion

	// #region Options

	popupOptions: DevExpress.ui.dxPopupOptions

	sendConfigurationProfileButtonOptions: DevExpress.ui.dxButtonOptions
	startButtonOptions: DevExpress.ui.dxButtonOptions
	stopButtonOptions: DevExpress.ui.dxButtonOptions
	finishButtonOptions: DevExpress.ui.dxButtonOptions

	savingProgressOptions: DevExpress.ui.dxProgressBarOptions

	selectBoxOptions: DevExpress.ui.dxSelectBoxOptions

	confirmChangeConfigurationProfile: ConfirmationOptions
	confirmBulkChanges: ConfirmationOptions
	confirmBulkEntities: ConfirmationOptions

	panels: any
	gridOptions: GridOptions | any

	// #endregion
}

// #endregion

export class LocationsMassSendConfigurationProfileController extends CommonCreateEdit implements ng.IComponentController, ILocationsMassSendConfigurationProfile {
	// #region Members

	private dataSource: LocationsMassSendConfigurationProfileDataSource

	private options: LocationsMassSendConfigurationProfileOptions

	private grid: DevExpress.ui.dxDataGrid
	private gridController: GridController<any>

	private gridColumns: DevExpress.ui.dxDataGridColumn[]
	private section: CreateEditSection

	private configurationProfiles: OpConfigurationProfile[]
	private selectedConfigurationProfile: OpConfigurationProfile
	private idConfigurationProfileSavedOnLocations: number
	private idProfileOnChange: number
	private locationsForSendAction: number[]
	private rowNamesForAction: string[]
	private isSaved: boolean

	private tabItems: any[]

	// #endregion

	// #region Ctor

	constructor(
		protected $scope: LocationsMassSendConfigurationProfileScope,
		$q: ng.IQService,
		$timeout: ng.ITimeoutService,
		private $sce: ng.ISCEService,
		protected api: Api,
		protected localDictionary: LocalDictionaryFactory,
		protected userSession: IUserSession,
		private readonly gridService: GridService,
		protected referenceTypeService: ReferenceTypeService,
		protected readonly operatorSecurityService: OperatorSecurityService
	) {
		super($scope, api, localDictionary, $q, $timeout, userSession, referenceTypeService, operatorSecurityService)
	}

	// #endregion

	// #region IComponentController

	public $onInit(): void {
		this.onInitialized()
	}

	// #endregion

	// #region Events

	private onInitialized(): void {
		if (this.options != null && _.isFunction(this.options.onInitialized)) {
			this.options.onInitialized(this)
		}
	}

	private onGridRowPrepared(args: any): void {
		if (args.rowType == 'data') {
			if (args.data != null) {
				if (args.data.success == null && args.data.error == null && args.data.warning == null) {
					args.isExpanded = false
				}

				const shouldExpandRow: boolean = args.data.error != null || args.data.warning != null

				if (shouldExpandRow) {
					args.isExpanded = shouldExpandRow
				}
			}
		}
	}

	private onGridInitialized(args: any, ctrl: GridController<any>): void {
		this.grid = args.component
		this.gridController = ctrl
	}

	private onSelectBoxValueChanged(args: any): void {
		if (this.$scope.isStartButtonFinished) {
			this.idProfileOnChange = args.value
			this.$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.popupId, LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ChangeOfProfileText))
		} else {
			this.updateSelectedProfile(args.value)
			this.$scope.actualLocation = 0
			this.$scope.uploadedPercent = 0
			this.idConfigurationProfileSavedOnLocations = null
			this.$scope.isStartButtonFinished = false
			this.restoreGrid()
		}
	}

	private onPopupShowing(): void {
		this.isSaved = false
	}

	private onPopupHiding(): void {
		this.reset()
	}

	private onStartClick(args: any): void {
		if (this.selectedConfigurationProfile != null) {
			this.isSaved = false
			this.$scope.isStartButtonFinished = false
			this.locationsForSendAction = []
			this.rowNamesForAction = []
			this.idConfigurationProfileSavedOnLocations = null

			this.submit()
		} else {
			ToastHelper.showInfo(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoConfigurationProfileSelected))
		}
	}

	private onSendConfigurationProfileClick(args: any): void {
		this.sendLocationConfigurationProfile()
	}

	private onStopClick(args: any): void {
		this.isSaved = false
		this.$scope.isStarted = false
	}

	private onFinishClick(args: any): void {
		this.$scope.popupVisible = false
	}

	// #endregion

	// #region Setup

	private getGridButtonsOptions(): any {
		return {
			enabled: true,
		}
	}

	private getGridMasterDetailOptions(): any {
		return {
			enabled: true,
			autoExpandAll: false,

			template: function (container, options) {
				let error: string = options.data.error
				if (error != null) {
					container.append($('<div ><p>' + error + '</p></div>'))
				}

				let warning: string = options.data.warning
				if (warning != null) {
					container.append($('<div ><p>' + warning + '</p></div>'))
				}
			},
		}
	}

	private getGridEditingOptions(): any {
		return {
			mode: 'cell',
			allowAdding: false,
			allowUpdating: false,
			allowDeleting: false,
		}
	}

	private setGridOptions(): void {
		this.$scope.gridOptions = {
			addCustomFilters: true,
			type: GridTypes.PAGINATED_SMALL,
			columns: this.gridColumns,
			dataSource: new DataSource(this.dataSource.gridData),
			idReferenceType: LocationService.REFERENCE_TYPE,

			editing: this.getGridEditingOptions(),
			masterDetail: this.getGridMasterDetailOptions(),
			buttonsOptions: this.getGridButtonsOptions(),

			onInitialized: (args: any, ctrl: GridController<any>) => {
				this.onGridInitialized(args, ctrl)
			},
			onRowPrepared: (args: any) => {
				this.onGridRowPrepared(args)
			},
		}
	}

	private setConsts(): void {
		this.$scope.popupId = new Date().getTime()
		this.$scope.ACTION_STATUS_POPUP_ID = this.$scope.popupId + '_ACTION_STATUS_POPUP'
		this.$scope.bulkEditWarningId = new Date().getTime() + 'bulkWarning'

		this.$scope.titleSummary = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SavingSummary)
	}

	private setTabsOptions(): void {
		this.tabItems = [this.section].map((section: CreateEditSection) => {
			return {
				template: (itemData: any, itemIndex: number, itemElement: any) => {
					this.$scope['showSectionError' + itemIndex] = false
					return (
						section.name +
						'<ng-md-icon ng-show="showSectionError' +
						itemIndex +
						'" icon="' +
						window['config']['ICONS']['REQUIRED_TAB'] +
						'" style="fill: #ea4444; vertical-align: middle;" size="20"></ng-md-icon>'
					)
				},
			}
		})
	}

	private setButtonsOption(): void {
		this.$scope.sendConfigurationProfileButtonOptions = {
			text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.StartAction),
			bindingOptions: {
				disabled: '!isStartButtonFinished',
			},
			onClick: (args: any) => {
				this.onSendConfigurationProfileClick(args)
			},
		}

		this.$scope.startButtonOptions = {
			text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.StartSave),
			bindingOptions: {
				disabled: 'isStarted',
			},
			onClick: (args: any) => {
				this.onStartClick(args)
			},
		}

		this.$scope.stopButtonOptions = {
			text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Stop),
			bindingOptions: {
				disabled: '!isStarted',
			},
			onClick: (args: any) => {
				this.onStopClick(args)
			},
		}

		this.$scope.finishButtonOptions = {
			text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Finish),
			bindingOptions: {
				disabled: 'isStarted',
			},
			onClick: (args: any) => {
				this.onFinishClick(args)
			},
		}
	}

	private setSelectBoxOptions(): void {
		this.$scope.selectBoxOptions = {
			displayExpr: 'name',
			valueExpr: 'id',
			noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
			placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SelectProfile),

			bindingOptions: {
				dataSource: 'profileSelectBoxItems',
				disabled: 'isStarted',
			},

			onValueChanged: (args: any) => {
				this.onSelectBoxValueChanged(args)
			},
		}
	}

	private setSavingProgressOptions(): void {
		this.$scope.savingProgressOptions = {
			visible: true,
			value: 0,
			min: 0,
			max: 100,

			bindingOptions: {
				value: 'uploadedPercent',
			},

			statusFormat: (ratio: any, value: any) => {
				return this.getProgressStatusFormat(ratio, value)
			},
		}
	}

	private setConfirmationOptions(): void {
		this.$scope.confirmChangeConfigurationProfile = {
			title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ChangeOfProfile),
			question: null,

			onConfirmed: () => {
				this.updateSelectedProfile(this.idProfileOnChange)
				this.$scope.actualLocation = 0
				this.$scope.uploadedPercent = 0
				this.idConfigurationProfileSavedOnLocations = null
				this.$scope.isStartButtonFinished = false
				this.restoreGrid()
				this.idProfileOnChange = null
			},

			onDeclined: () => {
				this.idProfileOnChange = null
			},
		}
	}

	private setPopupOptions(): void {
		this.$scope.popupOptions = {
			fullScreen: true,
			showTitle: true,
			closeOnOutsideClick: false,

			bindingOptions: {
				visible: 'popupVisible',
				title: 'title',
			},

			onHiding: () => {
				this.onPopupHiding()
			},
			onShowing: () => {
				this.onPopupShowing()
			},
		}
	}

	private setOptions(): JQueryPromise<void> {
		const location: OpLocation = this.gridService.getSourceObjectFromGridObject(this.dataSource.gridData[0], Enums.ReferenceType.IdLocation) as OpLocation

		const requestOptions: {
			groupReferenceType?: Enums.ReferenceType
			groupReferenceValue?: number
			viewReferenceType?: Enums.ReferenceType
		} = {
			groupReferenceType: Enums.ReferenceType.IdDistributor,
			groupReferenceValue: location.idDistributor,
			viewReferenceType: null,
		}

		return $.when<any>(
			this.gridService.getColumnModelByCategory(
				[Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_EDIT, Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PARAMS_REQUIRED],
				LocationService.SIMAX_MODULE_NAME,
				requestOptions
			),
			this.referenceTypeService.getReferenceObjects(Enums.ReferenceType.IdConfigurationProfile)
		).then((columnsArray: ColumnModel[][], configurationProfiles: DataProviderListResult<OpConfigurationProfile>) => {
			const [columns, requiredColumns]: ColumnModel[][] = columnsArray

			this.section = <CreateEditSection>{
				name: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Basics),
				type: 'form',
				columns: <any>columns,
				required: <any>requiredColumns,
			}

			this.configurationProfiles = configurationProfiles.objects
			this.configurationProfiles.forEach((profile: OpConfigurationProfile) => {
				const selectBoxItem: CorrespondingActionTypeModel = new CorrespondingActionTypeModel()
				selectBoxItem.id = profile.idConfigurationProfile
				selectBoxItem.name = profile.name

				this.$scope.profileSelectBoxItems.push(selectBoxItem)
			})
		})
	}

	private setDataSource(dataSource: LocationsMassSendConfigurationProfileDataSource): void {
		if (dataSource != null) {
			this.dataSource = dataSource

			if (this.dataSource.popupType != null) {
				this.$scope.popupType = this.dataSource.popupType
			}

			if (_.size(this.dataSource.columns) > 0) {
				this.gridColumns = this.dataSource.columns.map((column: DevExpress.ui.dxDataGridColumn) => {
					column.selectedFilterOperation = undefined
					column.filterValue = undefined
					column.filterValues = undefined
					column.width = undefined

					return column
				})
			}
		}
	}

	// #endregion

	// #region IMassSendConfigurationProfile

	public show(dataSource: LocationsMassSendConfigurationProfileDataSource): void {
		this.reset()

		this.$scope.popupVisible = true
		this.$scope.title = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.MassSendConfigurationProfile)
		this.$scope.panels = []

		this.setConsts()
		this.setButtonsOption()
		this.setPopupOptions()
		this.setConfirmationOptions()
		this.setSavingProgressOptions()
		this.setSelectBoxOptions()

		this.setDataSource(dataSource)

		this.setOptions().then(() => {
			this.setGridOptions()
			this.setTabsOptions()

			const sections: CreateEditSection[] = [this.section]

			sections.forEach((section: CreateEditSection) => {
				section.columns = section.columns.filter((item: CreateEditFieldSettings) => {
					return item.id != DataType.HELPER_ID_LOCATION
				})

				this.$scope.panels.push(section)
			})
		})
	}

	// #endregion

	// #region MassSendConfigurationProfileController

	private saveConfigurationProfileOnSingleLocation(locationId: number): void {
		if (!this.$scope.isStarted) {
			return
		}

		const locationConfigurationProfileToSave: OpLocationConfigurationProfile = new OpLocationConfigurationProfile(null)
		locationConfigurationProfileToSave.configurationProfile = this.selectedConfigurationProfile
		locationConfigurationProfileToSave.appliedDate = new Date()
		locationConfigurationProfileToSave.idLocation = locationId
		locationConfigurationProfileToSave.appliedOperator = this.userSession.getLoggedOperator()
		locationConfigurationProfileToSave.appliedOperator.actor.avatar = null
		locationConfigurationProfileToSave.configurationProfile.opState = Enums.OpChangeState.Modified

		this.userSession
			.getDataProvider()
			.Location.saveLocationConfigurationProfile(locationConfigurationProfileToSave)
			.then((result: OpLocationConfigurationProfile) => {
				this.dataSource.gridData[this.$scope.actualLocation].success = 'success'
				this.$scope.gridOptions.dataSource = new DataSource(this.dataSource.gridData)
				this.grid.repaint()
				this.locationsForSendAction.push(result.idLocation)

				const gridObj: any = _.find(this.dataSource.gridData, (x: any) => x.id == locationId)
				const sourceObject: OpLocation = this.gridService.getSourceObjectFromGridObject<OpLocation>(gridObj, LocationService.REFERENCE_TYPE)
				this.gridController.setItemDisplayState(sourceObject, { validation: Enums.ValidationStatus.Correct })

				this.userSession
					.getDataProvider()
					.Location.getLocation(result.idLocation)
					.then((location: OpLocation) => {
						this.rowNamesForAction.push(location.toString())
					})
			})
			.fail((error: any) => {
				LogHelper.error(LocationService.LOG_PREFIX, error)

				this.dataSource.gridData[this.$scope.actualLocation].error = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.WebServiceException)
				this.$scope.gridOptions.dataSource = new DataSource(this.dataSource.gridData)

				const gridObj: any = _.find(this.dataSource.gridData, (x: any) => x.id == locationId)
				const sourceObject: OpLocation = this.gridService.getSourceObjectFromGridObject<OpLocation>(gridObj, LocationService.REFERENCE_TYPE)
				this.gridController.setItemDisplayState(sourceObject, { validation: Enums.ValidationStatus.Incorrect })

				this.grid.repaint()
				this.grid.expandRow(this.dataSource.gridData[this.$scope.actualLocation])
			})
			.always(() => {
				this.$scope.actualLocation++
				this.updateUploadProgress()

				if (this.dataSource.gridData.length == this.$scope.actualLocation) {
					this.isSaved = false
					this.$scope.isStarted = false
					this.$scope.isStartButtonFinished = true
					this.idConfigurationProfileSavedOnLocations = locationConfigurationProfileToSave.configurationProfile.idConfigurationProfile

					return
				}

				const location: OpLocation = this.gridService.getSourceObjectFromGridObject(this.dataSource.gridData[this.$scope.actualLocation], Enums.ReferenceType.IdLocation) as OpLocation
				if (location != null) {
					this.saveConfigurationProfileOnSingleLocation(location.idLocation)
				}
			})
	}

	private getProgressStatusFormat(ratio: any, value: any): string {
		return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Progress) + ': ' + Math.round(ratio * 100) + '%'
	}

	private reset(): void {
		this.$scope.title = ''

		this.$scope.popupVisible = false
		this.$scope.isDescriptionShow = false
		this.$scope.isStarted = false
		this.$scope.isStartButtonFinished = false

		this.$scope.actualLocation = 0
		this.$scope.uploadedPercent = 0

		this.$scope.descriptionHtml = null

		this.selectedConfigurationProfile = null
		this.idConfigurationProfileSavedOnLocations = null
		this.selectedConfigurationProfile = null

		this.$scope.profileSelectBoxItems = []
		this.rowNamesForAction = []
		this.locationsForSendAction = []
	}

	private sendLocationConfigurationProfile(): void {
		if (_.size(this.locationsForSendAction) > 0 && this.idConfigurationProfileSavedOnLocations != null) {
			this.userSession
				.getDataProvider()
				.Location.sendLocationConfiguration(this.locationsForSendAction, this.idConfigurationProfileSavedOnLocations)
				.then((result: OpActionResult[]) => {
					const actionStatusOptions: ActionStatusOptions = {
						actionResult: result,
						selectedRowsNames: this.rowNamesForAction,
						moduleDataType: Enums.DataType.HELPER_ID_LOCATION,
					}

					this.$scope.$broadcast(EventsNames.SHOW_ACTION_STATUS_POPUP + this.$scope.ACTION_STATUS_POPUP_ID, actionStatusOptions)
				})
				.fail((error: any) => {
					ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.WebServiceException))
				})
		} else {
			ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoLocationToCreateTheAction))
		}
	}

	private updateSelectedProfile(idConfigurationProfile: number): void {
		const profiles: OpConfigurationProfile[] = this.configurationProfiles.filter((value: OpConfigurationProfile) => value.idConfigurationProfile == idConfigurationProfile)

		if (_.size(profiles) > 0) {
			this.selectedConfigurationProfile = profiles[0]

			if (this.selectedConfigurationProfile.configuationProfileFuntionsDescr != null) {
				this.$scope.isDescriptionShow = true
				this.$scope.descriptionHtml = this.$sce.trustAsHtml(this.selectedConfigurationProfile.configuationProfileFuntionsDescr.description)
			} else {
				this.$scope.isDescriptionShow = false
			}
		}
	}

	private updateUploadProgress(): void {
		this.$scope.uploadedPercent = (this.$scope.actualLocation / this.dataSource.gridData.length) * 100
	}

	private terminateSaving(): void {
		this.$scope.isStarted = false
		this.$scope.actualLocation = 0
		this.updateUploadProgress()
		this.restoreGrid()
	}

	private restoreGrid(): void {
		for (let i = 0; i < this.dataSource.gridData.length; i++) {
			this.dataSource.gridData[i].success = null
			this.dataSource.gridData[i].error = null
		}

		this.gridController.clearItemDisplayStates()

		this.$scope.gridOptions.dataSource = new DataSource(this.dataSource.gridData)
		this.grid.repaint()
		this.grid.collapseAll(-1)
	}

	private submit(): void {
		if (this.dataSource.gridData.length == this.$scope.actualLocation) {
			this.terminateSaving()
		}

		this.$scope.isStarted = true

		if (!this.isSaved) {
			this.isSaved = true
			this.saveLocationConfigurationProfile()
		} else {
			CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IncorrectData), 'error', 5000)
			angular.element('.dx-invalid').css('height', '36px')
		}
	}

	private saveLocationConfigurationProfile(): void {
		if (this.$scope.isStarted) {
			if (this.dataSource.gridData.length > this.$scope.actualLocation) {
				if (this.$scope.isStarted) {
					const location: OpLocation = this.gridService.getSourceObjectFromGridObject(this.dataSource.gridData[0], Enums.ReferenceType.IdLocation) as OpLocation
					this.saveConfigurationProfileOnSingleLocation(location.idLocation)
				} else {
					return
				}
			} else {
				this.$scope.isStarted = false
				this.isSaved = false
			}
		} else {
			this.terminateSaving()
			this.isSaved = false
		}
	}

	// #endregion
}
